export type Role =
  | 'ROLE_APPROVED_RADIO_CERTIFIER'
  | 'ROLE_APPROVED_RADIO_ENGINEER'
  | 'ROLE_APPROVED_RADIO_EXAMINER'
  | 'ROLE_CASUAL_USER'
  | 'ROLE_CLIENT'
  | 'ROLE_INVESTIGATIONS_MANAGER'
  | 'ROLE_LICENSING_MANAGER'
  | 'ROLE_LICENSING_OFFICER'
  | 'ROLE_MSG_SERVICE_CENTRE'
  | 'ROLE_RADIO_INVESTIGATOR'
  | 'ROLE_RSM_RADIO_ENGINEER'
  | 'ROLE_SENIOR_RADIO_INVESTIGATOR'
  | 'ROLE_SYSTEM_ADMINISTRATOR'
  | 'ROLE_PRIVATE_BAND_MANAGER'
  | 'ROLE_CROWN_BAND_MANAGER'
  | 'ROLE_RIGHT_HOLDER'
  | 'ROLE_GENERAL_USER'
  | 'ROLE_REGISTRAR'
  | 'ROLE_SPECIAL_USER'
  | 'ROLE_LICENSING_AGENCY'
  | 'ROLE_CAVEATOR'
  | 'ROLE_MORTGAGOR'
  | 'ROLE_MORTGAGEE';

// Roles blocked from general Search > Client menu and route.
// These roles have been assigned SEARCH_ACTIVE_CLIENT permissions for specific
// contexts (eg. callsign/licence transfers, client pickers) but should not access
// the general search UI to prevent unauthorized viewing of unlinked client addresses.
// See NZRRFASM-7119.
export const CLIENT_SEARCH_BLOCKED_ROLES: Role[] = ['ROLE_RIGHT_HOLDER', 'ROLE_PRIVATE_BAND_MANAGER', 'ROLE_MORTGAGOR', 'ROLE_CLIENT'];
